module.exports = __webpack_public_path__ + "media/images/icons/twotone/calendar-3bcbfee307493ea228451ebc8fa265c8.svg";